var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col h-full w-full" }, [
    _c("div", [_vm._t("header")], 2),
    _c("div", {}, [_vm._t("body")], 2),
    _c("div", [_vm._t("footer")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }